var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuctionFeatureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.997,
    height: 81,
    viewBox: "0 0 80.997 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83196",
    "data-name": "Group 83196",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M40.5,0A40.5,40.5,0,1,1,0,40.5,40.5,40.5,0,0,1,40.5,0Z",
    transform: "translate(0 0)",
    fill: "#ffeaae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(6.889 8.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11600",
    "data-name": "Group 11600",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3210",
    "data-name": "Rectangle 3210",
    width: 66.589,
    height: 66.592,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11599",
    "data-name": "Group 11599",
    transform: "translate(5.609 5.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11588",
    "data-name": "Group 11588",
    transform: "translate(2.016 45.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5556",
    "data-name": "Path 5556",
    d: "M8.206,52.07A2.022,2.022,0,0,0,6.19,54.086V56.1H26.35V54.086a2.022,2.022,0,0,0-2.016-2.016Z",
    transform: "translate(-5.182 -51.062)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5557",
    "data-name": "Path 5557",
    d: "M24.214,52.07H21.19a2.022,2.022,0,0,1,2.016,2.016V56.1H26.23V54.086A2.022,2.022,0,0,0,24.214,52.07Z",
    transform: "translate(-5.062 -51.062)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5558",
    "data-name": "Path 5558",
    d: "M11.23,52.07H8.206A2.022,2.022,0,0,0,6.19,54.086V56.1H9.214V54.086A2.022,2.022,0,0,1,11.23,52.07Z",
    transform: "translate(-5.182 -51.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5559",
    "data-name": "Path 5559",
    d: "M26.358,57.118H6.2A1.011,1.011,0,0,1,5.19,56.11V54.094A3.033,3.033,0,0,1,8.214,51.07H24.342a3.033,3.033,0,0,1,3.024,3.024V56.11A1.011,1.011,0,0,1,26.358,57.118ZM7.206,55.1H25.35V54.094a1.011,1.011,0,0,0-1.008-1.008H8.214a1.011,1.011,0,0,0-1.008,1.008Z",
    transform: "translate(-5.19 -51.07)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11589",
    "data-name": "Group 11589",
    transform: "translate(4.251 34.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5560",
    "data-name": "Path 5560",
    d: "M21.848,49.437a1.032,1.032,0,0,1-.716-.292,1,1,0,0,1,0-1.421L22.554,46.3a1.005,1.005,0,0,1,1.421,1.421l-1.421,1.421a.99.99,0,0,1-.716.292Z",
    transform: "translate(-7.3 -40.022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5561",
    "data-name": "Path 5561",
    d: "M19.258,47.718a.845.845,0,0,1-.383-.081,1.012,1.012,0,0,1-.544-1.321l1.159-2.792a1.01,1.01,0,1,1,1.865.776L20.2,47.093a1.016,1.016,0,0,1-.927.625Z",
    transform: "translate(-7.321 -40.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5562",
    "data-name": "Path 5562",
    d: "M16.2,47.126a1.011,1.011,0,0,1-1.008-1.008v-5.04a1.008,1.008,0,1,1,2.016,0v5.04A1.011,1.011,0,0,1,16.2,47.126Z",
    transform: "translate(-7.345 -40.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5563",
    "data-name": "Path 5563",
    d: "M13.144,47.711a1,1,0,0,1-.927-.625l-.776-1.865a1.01,1.01,0,1,1,1.865-.776l.776,1.865a1.017,1.017,0,0,1-.927,1.4Z",
    transform: "translate(-7.376 -40.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5564",
    "data-name": "Path 5564",
    d: "M11.221,43.084a1,1,0,0,1-.927-.625l-.383-.927a1.01,1.01,0,1,1,1.865-.776l.383.927A1.012,1.012,0,0,1,11.614,43a1.044,1.044,0,0,1-.383.081Z",
    transform: "translate(-7.388 -40.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5565",
    "data-name": "Path 5565",
    d: "M10.555,49.443a1.032,1.032,0,0,1-.716-.292L7.7,47.014a1.005,1.005,0,0,1,1.421-1.421l2.137,2.137a1,1,0,0,1,0,1.421.99.99,0,0,1-.716.292Z",
    transform: "translate(-7.407 -40.028)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11597",
    "data-name": "Group 11597",
    transform: "translate(11.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11590",
    "data-name": "Group 11590",
    transform: "translate(19.117 19.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3211",
    "data-name": "Rectangle 3211",
    width: 4.032,
    height: 10.08,
    transform: "translate(1.01 3.849) rotate(-45)",
    fill: "#2758a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3212",
    "data-name": "Rectangle 3212",
    width: 2.016,
    height: 10.08,
    transform: "translate(2.431 2.423) rotate(-45)",
    fill: "#1b4a8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5566",
    "data-name": "Path 5566",
    d: "M39.188,34.706a1.033,1.033,0,0,1-.716-.292l-4.99-4.99A1.005,1.005,0,1,1,34.9,28l4.99,4.99a1,1,0,0,1,0,1.421.99.99,0,0,1-.716.292Z",
    transform: "translate(-33.188 -24.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5567",
    "data-name": "Path 5567",
    d: "M44.155,34.013a1.033,1.033,0,0,1-.716-.292l-7.127-7.127a1.005,1.005,0,0,1,1.421-1.421L44.86,32.3a1,1,0,0,1,0,1.421.99.99,0,0,1-.716.292Z",
    transform: "translate(-33.165 -24.877)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11591",
    "data-name": "Group 11591",
    transform: "translate(26.367 26.381)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3213",
    "data-name": "Rectangle 3213",
    width: 6.048,
    height: 21.168,
    rx: 2,
    transform: "translate(0.175 4.406) rotate(-45)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5568",
    "data-name": "Path 5568",
    d: "M58.36,45.771,46.244,33.655a2.02,2.02,0,0,0-2.853,0L41.97,35.076a2.02,2.02,0,0,1,2.853,0L56.939,47.193a2.02,2.02,0,0,1,0,2.853l1.421-1.421A2.02,2.02,0,0,0,58.36,45.771Z",
    transform: "translate(-40.367 -32.095)",
    fill: "#2758a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5569",
    "data-name": "Path 5569",
    d: "M55.512,48.619,43.4,36.5a2.02,2.02,0,0,1,0-2.853l-1.421,1.421a2.02,2.02,0,0,0,0,2.853L54.091,50.041a2.02,2.02,0,0,0,2.853,0l1.421-1.421A2.02,2.02,0,0,1,55.512,48.619Z",
    transform: "translate(-40.372 -32.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5570",
    "data-name": "Path 5570",
    d: "M51.879,40.337a1.033,1.033,0,0,1-.716-.292l-1.421-1.431a1.005,1.005,0,1,1,1.421-1.421l1.421,1.431a1,1,0,0,1,0,1.421.99.99,0,0,1-.716.292Z",
    transform: "translate(-40.307 -32.064)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5571",
    "data-name": "Path 5571",
    d: "M55.52,51.656a3,3,0,0,1-2.137-.887L41.267,38.652a3.018,3.018,0,0,1,0-4.274l1.421-1.421a3.1,3.1,0,0,1,4.274,0L49.1,35.094a1.005,1.005,0,1,1-1.421,1.421l-2.137-2.137a1.023,1.023,0,0,0-1.421,0L42.7,35.8a1.022,1.022,0,0,0,0,1.431L54.815,49.348a1.023,1.023,0,0,0,1.421,0l1.421-1.421a1.016,1.016,0,0,0,0-1.431l-4.274-4.274A1.005,1.005,0,0,1,54.8,40.8l4.274,4.274a3.024,3.024,0,0,1,0,4.274l-1.421,1.421A3,3,0,0,1,55.52,51.656Z",
    transform: "translate(-40.38 -32.102)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11592",
    "data-name": "Group 11592",
    transform: "translate(4.854 13.392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3214",
    "data-name": "Rectangle 3214",
    width: 4.032,
    height: 13.104,
    transform: "translate(1.018 3.854) rotate(-45)",
    fill: "#2758a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3215",
    "data-name": "Rectangle 3215",
    width: 4.032,
    height: 2.016,
    transform: "translate(8.853 11.693) rotate(-45)",
    fill: "#1b4a8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3216",
    "data-name": "Rectangle 3216",
    width: 4.032,
    height: 2.016,
    transform: "translate(1.016 3.854) rotate(-45)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5572",
    "data-name": "Path 5572",
    d: "M29.248,33.269a1.033,1.033,0,0,1-.716-.292,1,1,0,0,1,0-1.421L31.385,28.7a1.005,1.005,0,0,1,1.421,1.421l-2.853,2.853a.99.99,0,0,1-.716.292Z",
    transform: "translate(-18.964 -19.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5573",
    "data-name": "Path 5573",
    d: "M20.048,24.079a1.033,1.033,0,0,1-.716-.292,1,1,0,0,1,0-1.421l2.853-2.853a1.005,1.005,0,0,1,1.421,1.421l-2.853,2.853a.99.99,0,0,1-.716.292Z",
    transform: "translate(-19.037 -19.217)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11593",
    "data-name": "Group 11593",
    transform: "translate(13.412 4.844)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3217",
    "data-name": "Rectangle 3217",
    width: 4.032,
    height: 13.104,
    transform: "translate(1.008 3.852) rotate(-45)",
    fill: "#2758a8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3218",
    "data-name": "Rectangle 3218",
    width: 4.032,
    height: 2.016,
    transform: "translate(8.85 11.694) rotate(-45)",
    fill: "#1b4a8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3219",
    "data-name": "Rectangle 3219",
    width: 4.032,
    height: 2.016,
    transform: "translate(1.006 3.851) rotate(-45)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5574",
    "data-name": "Path 5574",
    d: "M37.728,24.789a1.032,1.032,0,0,1-.716-.292,1,1,0,0,1,0-1.421l2.853-2.853a1.005,1.005,0,0,1,1.421,1.421L38.434,24.5a.99.99,0,0,1-.716.292Z",
    transform: "translate(-27.454 -10.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5575",
    "data-name": "Path 5575",
    d: "M28.538,15.6a1.033,1.033,0,0,1-.716-.292,1,1,0,0,1,0-1.421l2.853-2.853A1.005,1.005,0,1,1,32.1,12.454l-2.853,2.853a.99.99,0,0,1-.716.292Z",
    transform: "translate(-27.528 -10.737)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11594",
    "data-name": "Group 11594",
    transform: "translate(6.993 6.961)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3220",
    "data-name": "Rectangle 3220",
    width: 8.064,
    height: 15.12,
    transform: "translate(1.014 6.718) rotate(-45)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3221",
    "data-name": "Rectangle 3221",
    width: 8.064,
    height: 3.024,
    transform: "translate(9.561 15.269) rotate(-45)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3222",
    "data-name": "Rectangle 3222",
    width: 8.064,
    height: 3.024,
    transform: "translate(1.02 6.721) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5576",
    "data-name": "Path 5576",
    d: "M32.863,31.257a1.041,1.041,0,0,1-.716-.292l-10.695-10.7a1,1,0,0,1-.292-.716,1.041,1.041,0,0,1,.292-.716l5.705-5.706a1,1,0,0,1,1.421,0l10.695,10.7a1,1,0,0,1,0,1.421l-5.705,5.706a1,1,0,0,1-.716.292ZM23.6,19.554l9.264,9.264,4.274-4.274-9.264-9.264Z",
    transform: "translate(-21.16 -12.837)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11595",
    "data-name": "Group 11595",
    transform: "translate(0 15.685)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3223",
    "data-name": "Rectangle 3223",
    width: 6.048,
    height: 17.136,
    rx: 2,
    transform: "translate(0.165 4.413) rotate(-45)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M29.291,32.247,27.154,30.11a2.02,2.02,0,0,1,0,2.853l-1.421,1.421a2.02,2.02,0,0,1-2.853,0l2.137,2.137a2.02,2.02,0,0,0,2.853,0L29.291,35.1a2.02,2.02,0,0,0,0-2.853Z",
    transform: "translate(-14.153 -21.423)",
    fill: "#2758a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5578",
    "data-name": "Path 5578",
    d: "M17.942,26.613l1.421-1.421a2.02,2.02,0,0,1,2.853,0l-2.137-2.137a2.02,2.02,0,0,0-2.853,0L15.8,24.476a2.02,2.02,0,0,0,0,2.853l2.137,2.137a2.02,2.02,0,0,1,0-2.853Z",
    transform: "translate(-14.215 -21.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5579",
    "data-name": "Path 5579",
    d: "M26.508,38.193a3,3,0,0,1-2.137-.887l-9.264-9.264a3.024,3.024,0,0,1,0-4.274l1.421-1.421a3.1,3.1,0,0,1,4.274,0l2.137,2.137a1.005,1.005,0,0,1-1.421,1.421l-2.137-2.137a1.023,1.023,0,0,0-1.421,0L16.538,25.19a1,1,0,0,0,0,1.421L25.8,35.875a1.023,1.023,0,0,0,1.421,0l1.421-1.421a1,1,0,0,0,0-1.421l-4.99-4.99a1.005,1.005,0,0,1,1.421-1.421l4.99,4.99a3.024,3.024,0,0,1,0,4.274l-1.421,1.421a3,3,0,0,1-2.137.887Z",
    transform: "translate(-14.222 -21.492)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11596",
    "data-name": "Group 11596",
    transform: "translate(15.675)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3224",
    "data-name": "Rectangle 3224",
    width: 6.048,
    height: 17.136,
    rx: 2,
    transform: "translate(0.175 4.408) rotate(-45)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5580",
    "data-name": "Path 5580",
    d: "M44.841,16.7,42.7,14.56a2.02,2.02,0,0,1,0,2.853l-1.421,1.421a2.02,2.02,0,0,1-2.853,0l2.137,2.137a2.02,2.02,0,0,0,2.853,0l1.421-1.421A2.02,2.02,0,0,0,44.841,16.7Z",
    transform: "translate(-29.703 -5.863)",
    fill: "#2758a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5581",
    "data-name": "Path 5581",
    d: "M33.5,11.053l1.421-1.421a2.02,2.02,0,0,1,2.853,0L35.639,7.495a2.02,2.02,0,0,0-2.853,0L31.365,8.916a2.02,2.02,0,0,0,0,2.853L33.5,13.906a2.02,2.02,0,0,1,0-2.853Z",
    transform: "translate(-29.764 -5.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5582",
    "data-name": "Path 5582",
    d: "M42.058,22.633a2.982,2.982,0,0,1-2.137-.887l-9.264-9.264a3.024,3.024,0,0,1,0-4.274l1.421-1.421a3.1,3.1,0,0,1,4.274,0l2.137,2.137a1.005,1.005,0,0,1-1.421,1.421L34.931,8.208a1.023,1.023,0,0,0-1.421,0L32.088,9.63a1.016,1.016,0,0,0,0,1.431l9.264,9.264a1,1,0,0,0,1.421,0l1.421-1.431a1.022,1.022,0,0,0,0-1.431l-4.99-4.99a1.005,1.005,0,0,1,1.421-1.421l4.99,4.99a3.018,3.018,0,0,1,0,4.274l-1.421,1.431A3.041,3.041,0,0,1,42.058,22.633Z",
    transform: "translate(-29.773 -5.932)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11598",
    "data-name": "Group 11598",
    transform: "translate(0 49.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5583",
    "data-name": "Path 5583",
    d: "M29.4,57.086H4.2a1.008,1.008,0,0,1,0-2.016H29.4a1.008,1.008,0,0,1,0,2.016Z",
    transform: "translate(-3.19 -55.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5584",
    "data-name": "Path 5584",
    d: "M33.206,57.086H32.2a1.008,1.008,0,0,1,0-2.016h1.008a1.008,1.008,0,0,1,0,2.016Z",
    transform: "translate(-2.966 -55.07)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionFeatureIcon);
export default __webpack_public_path__ + "static/media/auction_feature_icon.e665e8a9dccf885a518b6c670693875a.svg";
export { ForwardRef as ReactComponent };